export default "__VITE_ASSET__CJ73lUPk__"